module.exports = __webpack_public_path__ + "static/flameskull-75ea0222859a3b0e21068a91600855ae.png";